import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { useAuth } from '../hooks/useAuth'
import ResetPasswordModal from './ResetPasswordModal'
import SetupPinModal from './SetupPinModal'

export default function OnboardingFlow() {
   const { user, refreshUser } = useAuth()
   const [showPasswordReset, setShowPasswordReset] = useState(false)
   const [showPinSetup, setShowPinSetup] = useState(false)

   useEffect(() => {
      if (user) {
         if (user.passwordShouldReset) {
            setShowPasswordReset(true)
         } else if (!user.isPinSetup) {
            setShowPinSetup(true)
         }
      }
   }, [user])

   const handlePasswordResetSuccess = async () => {
      setShowPasswordReset(false)
      toast.success('Password reset successfully!')
      await refreshUser()
      
      if (user && !user.isPinSetup) {
         setTimeout(() => setShowPinSetup(true), 300)
      }
   }

   const handlePinSetupSuccess = async () => {
      setShowPinSetup(false)
      toast.success('PIN setup successfully!')
      await refreshUser()
   }

   return (
      <>
         {user?.passwordResetToken && (
            <ResetPasswordModal
               open={showPasswordReset}
               onClose={() => setShowPasswordReset(false)}
               onSuccess={handlePasswordResetSuccess}
               passwordResetToken={user.passwordResetToken}
            />
         )}
         <SetupPinModal
            open={showPinSetup}
            onSuccess={handlePinSetupSuccess}
         />
      </>
   )
}
